<!--
 * @FileDescription: 公共头部（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="public-header" id="header">
    <div class="public-header-left">
      <img src="@/assets/image/logo.png" alt="logo" class="image-logo">
    </div>
    <div class="public-header-right">
      <div class="public-header-right-img">
        <img src="@/assets/image/logo3.png" alt="logo" class="image-logo1">
      </div>
      <div style="display: flex;align-items: center">
        <div class="function-icon-box">
          <!-- <div class="function-icon remaining-time">
            <img src="@/assets/image/home_time.png" class="icon-image" alt="体验时间">
            <span class="stores-name">体验时间仅剩{{ $store.state.userInfo.remainingTime }}天</span>
          </div> -->
          <div class="function-icon">
            <img src="@/assets/image/dingwei.png" class="icon-image" alt="门店名称">
            <span class="stores-name">{{ $store.state.userInfo.storeName }}</span>
          </div>
          <div class="function-icon" @click="$router.push('/systemoverview/overview/mustdo')"
            v-if="$store.state.storeType == 1 && accountType == 1">
            <a-tooltip slot="suffix" title="初始设置">
              <img src="@/assets/image/qizi1.png" class="icon-image1" alt="新手必做">
            </a-tooltip>
          </div>
          <div class="function-icon" @click="$router.push('/systemoverview/overview/helpContent')"
            v-if="$store.state.storeType == 1">
            <a-tooltip slot="suffix" title="帮助中心">
              <img src="@/assets/image/WechatIMG89.png" class="icon-image" alt="问题">
            </a-tooltip>
          </div>
          <div class="function-icon" @click="onClickModel()" v-if="$store.state.storeType == 1">
            <a-tooltip slot="suffix" title="联系客服">
              <img src="@/assets/image/kefu.png" class="icon-image" alt="电话">
            </a-tooltip>
          </div>
          <div class="function-icon" @click="$router.push('/systemoverview/overview/message')"
            v-if="$store.state.storeType == 1">
            <a-tooltip slot="suffix" title="消息中心">
              <img src="@/assets/image/xiaoxi@2x.png" class="icon-image" alt="消息">
            </a-tooltip>
          </div>
          <div class="user-information">
            <div class="user-image">
              <img src="@/assets/image/touxiang.png" alt="用户头像" class="image">
            </div>
            <div class="user-name">
              <a-popover placement="bottomRight" class="user-name-popover">
                <template slot="content">
                  <p @click="onShop()" v-if="$store.state.storeType == 1">切换门店</p>
                  <p @click="AmendPassword">账号设置</p>
                  <p @click="LogOut">退出登录</p>
                </template>
                <template slot="title">
                  <span v-if="!isEmpty($store.state.userInfo.loginName)">{{$store.state.userInfo.loginName}}</span>
                  <span v-else>{{$store.state.userInfo.roleName}}</span>
                </template>
                <span class="ant-dropdown-link">
                  <span v-if="!isEmpty($store.state.userInfo.loginName)">{{$store.state.userInfo.loginName}}</span>
                  <span v-else>{{$store.state.userInfo.roleName}}</span>
                  <a-icon type="caret-down" style="color: #CCCCCC" />
                </span>
              </a-popover>
            </div>
          </div>
        </div>
        <!--<div class="function-icon">-->
        <!--<a-popover placement="bottomRight">-->
        <!--<template slot="content">-->
        <!--<div class="setting-box">-->
        <!--<div class="setting-box-top">-->
        <!--<span>放大倍率：</span>-->
        <!--<a-icon type="minus-circle" @click="btnSetting(2)" />-->
        <!--<a-slider :min="10" :max="150" :step="10" v-model="inputValue" />-->
        <!--<a-icon type="plus-circle" @click="btnSetting(1)" />-->
        <!--</div>-->
        <!--<div class="setting-box-bottom">-->
        <!--<span v-for="(item,index) in percentList" :key="index" :class="inputValue==item?'span-color' :''" @click="inputValue=item">{{ item }}%</span>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="select-theme">.else-menu-up.else-menu-up-->
        <!--<span>换肤：</span>-->
        <!--<span class="theme default-color" @click="changeTheme('blue')"></span>-->
        <!--<span class="theme hotness-red-color" @click="changeTheme('red')"></span>-->
        <!--<span class="theme partysu-color" @click="changeTheme('cyan')"></span>-->
        <!--</div>-->
        <!--</template>-->
        <!--<template slot="title">-->
        <!--<span style="padding: 10px 0">设置</span>-->
        <!--</template>-->
        <!--<img src="@/assets/image/shezhi@2x.png" class="icon-image" alt="设置">-->
        <!--</a-popover>-->
        <!--</div>-->
      </div>

    </div>
    <a-modal v-model="isShowModel" :footer="null" class="public-model">
      <div class="model-ke">
        <img src="@/assets/image/weixin.png" />
        <div>请扫码添加客服微信</div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { logoout, findCustomer } from "@/utils/api";

export default {
  name: "publicheader",
  data() {
    return {
      inputValue: 100,
      percentList: [100, 110, 120, 130, 140, 150],
      isShowModel: false,
      accountType: "",
    };
  },
  mounted() {
    this.accountType = sessionStorage.getItem("accountType");
  },
  methods: {
    /**
     * @description: 放大倍率（方法描述）
     * @param {Number} type：放大比例
     * @return void
     */
    btnSetting(type) {
      if (type == 1 && this.inputValue < 150) {
        this.inputValue += 10;
      } else if (type == 2 && this.inputValue >= 10) {
        this.inputValue -= 10;
      }
    },
    /**
     * @description: 切换主题（方法描述）
     * @param {String} theme：主题类别
     * @return void
     */
    changeTheme(type) {
      if (type == "blue") {
        window.less.modifyVars({
          "@primary-color": "rgba(56,123,252,1)",
          "@btn-bg":
            "linear-gradient(260deg,rgba(1,85,255,1),rgba(56,123,252,1))",
          "@btn-bg-hover":
            "linear-gradient(260deg,rgba(1,63,255,1),rgba(50,106,251,1))",
        });
      } else if (type == "red") {
        window.less.modifyVars({
          "@primary-color": "rgba(241,90,97,1)",
          "@btn-bg":
            "linear-gradient(260deg,rgba(241,90,97,1),rgba(241,90,97,1))",
          "@btn-bg-hover":
            "linear-gradient(260deg,rgba(241,90,97,1),rgba(241,90,97,1))",
        });
      } else if (type == "cyan") {
        window.less.modifyVars({
          "@primary-color": "rgba(53,185,197,1)",
          "@btn-bg":
            "linear-gradient(260deg,rgba(53,185,197,1),rgba(53,185,197,1))",
          "@btn-bg-hover":
            "linear-gradient(260deg,rgba(53,185,197,1),rgba(53,185,197,1))",
        });
      }
    },
    /**
     * @description: 退出登录（方法描述）
     * @param {参数类型} 参数名称
     * @return void
     */
    LogOut() {
      let data = new FormData();
      data.append("token", this.$store.state.token);
      logoout(data).then((res) => {
        if (res.success) {
          sessionStorage.clear();
          this.$router.replace({ path: "/" });
        } else {
          this.$message.warn(res.logMessage);
        }
      });
    },
    // 修改密码
    AmendPassword() {
      this.$router.push({ path: "/systemoverview/overview/setpassword" });
    },
    onShop() {
      this.$router.push({ path: "/shop" });
    },
    onClickModel() {
      this.isShowModel = true;
    },
  },
  watch: {
    /**
     * @description: 放大倍率（方法描述）
     * @param {参数类型} 参数名称
     * @return void
     */
    inputValue() {
      // 需要上传后端   防止刷新
      document.getElementsByTagName("body")[0].style.zoom =
        this.inputValue / 100;
    },
  },
};
</script>
<style lang="scss">
.public-model {
  width: 566px !important;
  height: 436px !important;
}
.public-header {
  height: 70px;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  /*background-color: var(--co);*/
  background: #fff;
  .public-header-left,
  .public-header-left-up {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    .image-logo {
      width: 70px;
      height: 70px;
      object-fit: cover;
    }
    .name {
      width: 200px;
      height: 54px;
      font-size: 24px;
      font-weight: 800;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 15px;
    }
  }
  .public-header-left {
    width: 90px;
    transition: 0.3s;
    background: var(--co);
  }
  .public-header-left-up {
    padding: 13px 0 0 20px;
    transition: 0.3s;
  }
  .public-header-right {
    flex: 1;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .public-header-right-img {
      margin-left: 20px;
      width: 125px;
      // height: 30px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .function-icon-box {
      height: 26px;
      display: flex;
      align-items: center;
      border-right: 1px solid #f2f2f2;
      .function-icon {
        cursor: pointer;
        padding-right: 20px;
        .icon-image {
          width: 20px;
          height: 20px;
        }
        .icon-image1 {
          width: 15px;
          height: 18px;
        }
        .stores-name {
          font-size: 18px;
          color: #333333;
          padding: 0 25px 0 10px;
        }
      }
      .remaining-time {
        height: 42px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        background-color: rgba($color: #F0320C, $alpha: 0.2);
        border-radius: 6px;
        margin-right: 24px;
        .icon-image {
          width: 18px;
          height: 18px;
        }
        .stores-name {
          font-size: 18px;
          color: #F0320C;
          padding-right: 0;
        }
      }
    }
    .user-information {
      height: 50px;
      display: flex;
      align-items: center;
      padding-right: 36px;
      .user-image {
        padding: 0 15px 0 30px;
        .image {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
      }
      .user-name {
        cursor: pointer;
        .anticon-caret-down {
          margin-left: 5px;
          vertical-align: -0.25em;
        }
      }
    }
  }
}
.ant-popover-inner-content {
  cursor: pointer;
  // padding: 12px 16px 12px 16px;
}
.setting-box {
  width: 434px;
  height: 72px;
  .setting-box-top {
    width: 434px;
    height: 36px;
    display: flex;
    align-items: center;
  }
  .ant-slider {
    width: 250px;
    padding: 2px 0;
    .ant-popover-title {
      padding: 10px;
    }
    .ant-slider-track,
    .ant-slider-handle {
      background-color: var(--co);
      border-color: var(--co);
    }
  }
  .ant-slider:hover {
    .ant-slider-handle:not(.ant-tooltip-open) {
      border-color: var(--co);
    }
    .ant-slider-track {
      background-color: var(--co);
    }
  }
  .anticon {
    font-size: 18px;
    margin: 0 16px;
  }
  .setting-box-bottom {
    padding-left: 104px;
    line-height: 20px;
    cursor: pointer;
    span {
      display: inline-block;
      width: 50px;
      text-align: center;
    }
    .span-color {
      color: var(--co);
      border-radius: 2px;
      background-color: var(--bgbltwo);
    }
  }
}
.select-theme {
  height: 62px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  .theme {
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    margin-right: 40px;
    cursor: pointer;
  }
  .default-color {
    margin-left: 10px;
    background-color: rgba(56, 123, 252, 1);
  }
  .hotness-red-color {
    background-color: #f15a61;
  }
  .partysu-color {
    background-color: #35b9c5;
  }
}
.ant-popover-inner-content {
  padding: 15px 16px 5px 16px;
}
.model-ke {
  width: 500px;
  height: 390px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #343434;
  font-size: 24px;
  img {
    margin-bottom: 20px;
  }
}
</style>
